import { Component, OnInit, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {TRANSLATE} from '../../classes/translatable';
import {SelectionModel} from '@angular/cdk/collections';

export class ArchiveValidationDialogData {
  archiveMessage: string           = TRANSLATE("Voulez-vous vraiment archiver les éléments");
  selection: SelectionModel<any>  = null;
  getRefToDisplay: any            = null;
  isArchive: boolean              = false;
}

@Component({
  selector: 'app-archive-validation-dialog',
  templateUrl: './archive-validation-dialog.component.html',
  styleUrls: ['./archive-validation-dialog.component.css']
})
export class ArchiveValidationDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ArchiveValidationDialogData>,
    @Inject(MAT_DIALOG_DATA) public data: ArchiveValidationDialogData
) { }

  ngOnInit() {
    if (!this.data) {
      this.data = new ArchiveValidationDialogData();
    }

    this.dialogRef.disableClose = true;
    if (!this.data.archiveMessage) {
      this.data.archiveMessage = this.data.isArchive ? TRANSLATE("Voulez-vous vraiment désarchiver les éléments") : TRANSLATE("Voulez-vous vraiment archiver les éléments");
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close(true);
  }

}
